var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrikethrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20.75,
    viewBox: "0 0 22 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7483 -16469.625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: "0.75px",
    stroke: "currentColor",
    d: "M7.432-1.06c3.445,0,6.022-2.3,6.022-5.322,0-3.081-2.185-4.79-5.63-5.63-2.829-.7-4.286-2.017-4.286-4.006a3.618,3.618,0,0,1,3.894-3.473,3.794,3.794,0,0,1,3.922,3.838h1.765A5.426,5.426,0,0,0,7.432-21.06c-3.249,0-5.686,2.213-5.686,5.1,0,2.941,2.045,4.734,5.294,5.49,3,.728,4.65,2.073,4.65,4.174S9.869-2.629,7.46-2.629A4.118,4.118,0,0,1,3.175-6.69H1.41A5.727,5.727,0,0,0,7.432-1.06Z",
    transform: "translate(-7479.91 16491.061)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "2px",
    stroke: "#fff",
    d: "M-7469,16603.473h22",
    transform: "translate(0 -0.973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "2px",
    stroke: "currentColor",
    d: "M-7469,16603.473h22",
    transform: "translate(0 0.527)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.2e193618.svg";
export { ForwardRef as ReactComponent };